import React, { Component } from "react"
import { AccountSearchFormSmall } from '../../search/AccountSearchFormSmall.jsx';
import I18n from 'i18n-js';
import '../../translations.js';
export class DynamicOwnerForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showSearch: false,
      ownerId: this.props.ownerId,
      ownerOptions: this.props.ownerOptions
    }
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleAddPerson = this.handleAddPerson.bind(this);
  }

  handleNameChange(e) {
    this.setState({ownerId: e.target.value});
    this.props.onNameChange(e.target.value, this.props.keyId);
    if (e.target.value === "new") {
      this.setState({ showSearch: e.target.id })
    } else {
      this.setState({ showSearch: false })
    }
  }

  handleAddPerson(e, target) {
    this.setState({
      ownerOptions: this.state.ownerOptions.concat([e].map(this.personAsOption)),
      ownerId: e.id,
      showSearch: false
    })
    this.props.addPerson(e, target)
  }

  personAsOption(x) {
    return <option key={x.id} value={x.id}>{x.name}</option>;
  };

  render() {
    return (
      <div>
        <div key={this.props.keyId}>
          <div className="control-group select optional user_equine_associations_name">
            <label className="select optional control-label">{I18n.t("horse.owner")} {this.props.keyId + 1}</label>
            <div className="controls">
              {this.props.disabled ? 
                <select className="select optional" value={this.props.ownerId} id="owner" disabled={this.props.disabled}>
                  {this.state.ownerOptions}
                </select> 
                :
                <select className="select optional" required={this.props.keyId == 0} value={this.state.ownerId} id={"owner" + this.props.keyId} onChange={this.handleNameChange}>
                  <option key="new" value="new">{I18n.t("user.person_not_my_account")}</option>
                  <option key="0" value=""></option>
                  {this.state.ownerOptions}
                </select>
              }
            </div>
          </div>
        </div>
        { this.state.showSearch ?
          <AccountSearchFormSmall
            target={this.state.showSearch}
            addPerson={this.handleAddPerson}
            company={true}
            />
          : undefined
        }
      </div>
    );
  }
}
